define('bindingHandlers/dataTable/endlessDataTable',[
    'jquery',
    'lib/lodash4',
    'lib/knockout',

    'bindingHandlers/dataTable/dataTable',
    'bindingHandlers/scrolled'
], function (
    $,
    _,
    ko
) {
    'use strict';

    var getLoadingRowTemplate = _.once(function () {
        var $LOADING_ROW = $('<div class="dt-row dt-row-loading">')
                                    .append('<div class="dt-cell"><div data-bind="loadIndicator: isLoading"></div></div>');

        ko.applyBindings({
            isLoading: true
        }, $LOADING_ROW[0]);

        return $LOADING_ROW;
    });

    /**
     * This binding handler works exactly like the Data Table binding and takes the same
     * input as its arguments. The only difference with this binding is that the paging state
     * is modified whenever the user scrolls down far enough in the table. When this event happens,
     * the onDataOptions callback is executed to load the data for the modified paging state.
     *
     * For information on the arguments for this binding handler, please see the Data Table
     * binding's documentation.
     */
    ko.bindingHandlers.endlessDataTable = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var options = ko.unwrap(valueAccessor());
            var hasIncrementedPage = false;

            ko.bindingHandlers.dataTable.init.apply(this, arguments);

            var $scrollableSection = $(".scrollable-section", element);

            var rowsSubscription = options.rows.subscribe(function () {
                hasIncrementedPage = false;

                $(".dt-row-loading", $scrollableSection).remove();
            });

            var incrementPageOnScroll = function () {
                if (_.has(options, "onDataOptionsChange") && !hasIncrementedPage) {
                    var newPageNumber = options.dataOptions().pageNumber + 1;

                    if (newPageNumber <= options.dataOptions().pageCount) {
                        options.onDataOptionsChange({
                            pageNumber: newPageNumber,
                            pageSize:   options.dataOptions().pageSize
                        });

                        hasIncrementedPage = true;

                        $scrollableSection.append(getLoadingRowTemplate().clone());
                    }
                }
            };

            if ($scrollableSection.length > 0) {
                ko.bindingHandlers.scrolled.init($scrollableSection[0], function () {
                    return incrementPageOnScroll;
                }, allBindings, viewModel, bindingContext);
            }

            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                rowsSubscription.dispose();
            });

            return { controlsDescendantBindings: true };

        }
    };
});

